import React from "react";
import { Box, Grid } from "@mui/material";
import { FormTextField } from "../controls";

export default function CustomerAddress(props) {
  const {
    customerAddress,
    schema,
    formErrors,
    register,
    index,
    readOnly,
    control,
    addressType
  } = props;

  function parseNumber(str) {
    if (typeof str !== "undefined") return str.replace(/[^0-9]/g, "");
    return "";
  }
  const errors = formErrors?.customerAddresses?.[index] || {};
  return (
    <>
      <Box display={"none"}>
        <FormTextField
          style={{ width: "100%" }}
          name={`customerAddresses[${index}].addressCode`}
          value={customerAddress?.addressCode || ""}
          inputRef={register}
          watchvalue={customerAddress?.addressCode || ""}
          schema={schema.addressCode}
          formErrors={errors.addressCode}
          size="small"
          control={control}
          readOnly={true}
        />
        <FormTextField
          style={{ width: "100%" }}
          name={`customerAddresses[${index}].addressType`}
          value={addressType ?? ""}
          inputRef={register}
          watchvalue={customerAddress?.addressType || ""}
          schema={schema.addressType}
          formErrors={errors.addressType}
          size="small"
          control={control}
          readOnly={true}
        />
      </Box>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={customerAddress?.address1 || ""}
            inputRef={register}
            name={`customerAddresses[${index}].address1`}
            watchvalue={customerAddress?.address1 || ""}
            schema={schema.address1}
            formErrors={errors.address1}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={customerAddress?.address2 || ""}
            inputRef={register}
            name={`customerAddresses[${index}].address2`}
            watchvalue={customerAddress?.address2}
            schema={schema.address2}
            formErrors={errors.address2}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={customerAddress?.address3 || ""}
            inputRef={register}
            name={`customerAddresses[${index}].address3`}
            watchvalue={customerAddress?.address3}
            schema={schema.address3}
            formErrors={errors.address3}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={customerAddress?.city || ""}
            inputRef={register}
            name={`customerAddresses[${index}].city`}
            watchvalue={customerAddress?.city}
            schema={schema.city}
            formErrors={errors.city}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={customerAddress?.state || ""}
            inputRef={register}
            name={`customerAddresses[${index}].state`}
            watchvalue={customerAddress?.state}
            schema={schema.state}
            formErrors={errors.state}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={customerAddress?.country || ""}
            inputRef={register}
            name={`customerAddresses[${index}].country`}
            watchvalue={customerAddress?.country}
            schema={schema.country}
            formErrors={errors.country}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={customerAddress?.zip || ""}
            inputRef={register}
            name={`customerAddresses[${index}].zip`}
            watchvalue={customerAddress?.zip}
            schema={schema.zip}
            formErrors={errors.zip}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={parseNumber(customerAddress?.phone1) || ""}
            inputRef={register}
            name={`customerAddresses[${index}].phone1`}
            watchvalue={customerAddress?.phone1}
            schema={schema.phone1}
            formErrors={errors.phone1}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={parseNumber(customerAddress?.phone2) || ""}
            inputRef={register}
            name={`customerAddresses[${index}].phone2`}
            watchvalue={customerAddress?.phone2}
            schema={schema.phone2}
            formErrors={errors.phone2}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            style={{ width: "100%" }}
            value={customerAddress?.contactPerson || ""}
            inputRef={register}
            name={`customerAddresses[${index}].contactPerson`}
            watchvalue={customerAddress?.contactPerson}
            schema={schema.contactPerson}
            formErrors={errors.contactPerson}
            size="small"
            readOnly={readOnly}
            control={control}
          />
        </Grid>
      </Grid >

    </>

  );
}
